export default {
    // Tile source
    sources: [
        {
            name: "cities",
            type: "geojson",
            data: "/data/cities.geojson"
        },
        
        {
            name: "episcope",
            type: "geojson",
            data: "/data/Oslo_EPISCOPE_OPT_2020_corrected.geojson"
        },
        {
            name: "enova",
            type: "geojson",
            data: "/data/oslo_addr.geojson"
        },
        {
            name: "ml",
            type: "geojson",
            data: "/data/Oslo_buildings.geojson"
        },
        {
            name: "buildings_source",
            type: "geojson",
            data: "/data/steinhausenplan_stadt_mkaiser.geojson"
        },
		{
            name: "ViennaLandUse",
            type: "vector",
            minzoom: 8,
            maxzoom: 12,
            tiles: [ window.location.origin + "/data/ViennaLanduse/mvt/{z}/{x}/{y}.pbf"],
            bounds: [16.181094096381106, 48.11695940362917, 16.585274498952334, 48.32431294088399]
        }

        
    ],

    layers: [

        {
            id: "construction_year",
            type: "circle",
            source: "episcope",
            paint: {
                "circle-color":['interpolate', ["linear"], ['get','construction_year'], 1960, '#555', 2025, '#000'],
                "circle-opacity": 0,
                "circle-radius":5
            }
        },
 
		{
            id: "ViennaLandUse_layer",
            type: "line",
            source: "ViennaLandUse",
            "source-layer": "ViennaLandUse",
            paint: {
                "line-width": 0.1,
                "line-opacity": 0
            }
        },
		{
            id: "ViennaLandUse_layerLimegreen",
            type: "line",
            source: "ViennaLandUse",
            "source-layer": "ViennaLandUse",
            paint: {
                "line-width": 1.5,
                "line-opacity": 0,
                //"line-color": "limegreen",
                "line-color": ['interpolate', ['linear'],['to-number', ['get', 'ZBEZ']], 
                1, '#ADFF2F',
                500, '#00FF00',
                1000, '#20B2AA',
                1500, '#7FFFD4',
                2300, '#00BFFF']
            }
        },
		{
            id: "ViennaLandUse_layerRandColors",
            type: "line",
            source: "ViennaLandUse",
            "source-layer": "ViennaLandUse",
            paint: {
                "line-width": 1,
                "line-opacity": 0,
                "line-color": ['interpolate', ['linear'],['to-number', ['get', 'ZBEZ']], 1, 'limegreen', 2300, 'orange']
            }
        },
        {
            id: "oep",
            type: "circle",
            source: "episcope",
            paint: {
                "circle-color": "blue",
                "circle-opacity": 0,
                "circle-radius":['/', ['get','observed_energy_performance'], 10]
            }
        },


        {
            id: "episcope_qh",
            type: "circle",
            source: "episcope",
            paint: {
                "circle-color": ['interpolate', ["linear"], ['get','QH_(kWh/m2a)_OPT_2020'], 0, '#f5a', 300, '#f00'],
                "circle-opacity": 0,
                "circle-radius": 2
            },
            layout: {
            }
        },

        {
            id: "enova",
            type: "circle",
            source: "enova",
            paint: {
                "circle-color":['interpolate-hcl', ["linear"], ['get','BeregnetLevertEnergiTotaltkWhm2'], 0, '#13f', 300, '#f62'],
                "circle-blur": 0,
                "circle-opacity": 0,
                "circle-radius":['interpolate', ["linear"], ['get','BeregnetLevertEnergiTotaltkWhm2'], 0, 4, 1000, 6]
            }
        },

        {
            id: "questionmarks",
            type: "symbol",
            source: "episcope",
            paint: {
                "text-color": "black",
                "text-opacity": 0
            },
            layout: {
                "text-font": ["Open Sans Bold"],
                "text-size": 12,
                "text-anchor": "top-right",
                "text-field": "?"//,
//                "visibility": "none",
            }
        },
        


        {
            id: "episcope_vs_gt",
            type: "circle",
            source: "episcope",
            paint: {
                "circle-color":['interpolate', ["linear"], 
                
                //['get','BeregnetLevertEnergiTotaltkWhm2'], 
                ['/',
                    ['get','observed_energy_performance'],
                    ['get','QH_(kWh/m2a)_OPT_2020']
                ],
                
                0.5, '#f00',
                1, '#0f0',
                1.5, '#f00'],
                //"circle-color":['interpolate-hcl', ["linear"], ['get','BeregnetLevertEnergiTotaltkWhm2'], 0, '#FFFF33', 300, '#ADFF2F'],
                "circle-opacity": 0,
                "circle-blur": 0,
                "circle-radius": 5
                //"circle-radius": 10 /*['interpolate', ["linear"], ['get','BeregnetLevertEnergiTotaltkWhm2'], 0, 8, 1000, 10]*/
            }
        },
        {
            id: "episcope_vs_gt_label",
            type: "symbol",
            source: "episcope",
            paint: {
                "text-color": "black"
            },
            layout: {
                "text-font": ["Open Sans Bold"],
                "text-size": 12,
                "text-anchor": "top-right",
                //['get','BeregnetLevertEnergiTotaltkWhm2'], 
                "text-field": ["number-format", ['/',
                    ['get','observed_energy_performance'],
                    ['get','QH_(kWh/m2a)_OPT_2020']
                ],{
                    "min-fraction-digits": 1,
                    "max-fraction-digits": 2
                }],
                "visibility": "none",
            }
        },
        
        {
            id: "ml",
            type: "fill-extrusion",
            source: "ml",
            paint: {
                //"fill-color": "#00f",
                //"fill-opacity": 0.5,
                "fill-extrusion-color": ["interpolate", ["linear"], ["get", "total_wall_area"], 0, "#00f", 7000, "#f00"],
                "fill-extrusion-height": ["get", "height"],
                "fill-extrusion-opacity": 0.65
            },
            layout: {
                "visibility": "none"
            }
        },

        {
            id: "buildings",
            type: "fill-extrusion",
            source: "buildings_source",
            paint: {
                //"fill-opacity": 0.5,
                "fill-extrusion-color":
                // Map the id from 1 to 1414 to a color in a viridis palette
                ['interpolate', ['linear'], ['get', 'id'], 1, '#a00000', 700,  '#ea801c', 1414, '#2066a8'],
                //['interpolate', ["linear"], ["get", "total_wall_area"], 0, "#00f", 7000, "#f00"],
                "fill-extrusion-height": 10,//["get", "height"],
                "fill-extrusion-opacity": 0.65
            },
            layout: {
                "visibility": "none"
            }
        },
        

        {
            id: "buildingsAltColor1",
            type: "fill-extrusion",
            source: "buildings_source",
            paint: {
                //"fill-opacity": 0.5,
                "fill-extrusion-color":
                // Map the id from 1 to 1414 to a color in a plasma palette
                ['interpolate', ['linear'], ['get', 'id'], 1, 'rgb(240,249,33)', 500,  'rgb(244,136,73)', 900,  'rgb(185,50,137)', 1414, 'rgb(13,8,135)'],
                //['interpolate', ["linear"], ["get", "total_wall_area"], 0, "#00f", 7000, "#f00"],
                "fill-extrusion-height": 10,//["get", "height"],
                "fill-extrusion-opacity": 0.65
            },
            layout: {
                "visibility": "none"
            }
        },
        {
            id: "buildingsGray",
            type: "fill-extrusion",
            source: "buildings_source",
            paint: {
                "fill-extrusion-color": 'darkgray',
                "fill-extrusion-height": 20,//["get", "height"],
                "fill-extrusion-opacity": 0.1
            },
            layout: {
                "visibility": "none"
            }
        },
                
       {
            id: "city_emojis",
            type: "symbol",
            source: "cities",
            minzoom: 0,
            maxzoom: 24,
            layout: {
                "icon-image": "building",       // <-- use the loaded icon
                "icon-size": 0.6,
                "icon-allow-overlap": true,
                "text-field": ["get", "name"],  // <-- just show city name
                "text-size": 14,
                "text-anchor": "top",
                "text-offset": [0, 0.8]
            },
            paint: {
                "text-halo-color": "#ffffff",
                "text-halo-width": 1.5,
                "icon-opacity": 0,
                "text-opacity": 0
            }
        }


    ]
};
